module.exports = __webpack_public_path__ + "img/d-cutBag.c0b97eb2.jpg";